import { render, staticRenderFns } from "./investmentPenetration.vue?vue&type=template&id=269cebe4&scoped=true"
import script from "./investmentPenetration.vue?vue&type=script&lang=js"
export * from "./investmentPenetration.vue?vue&type=script&lang=js"
import style0 from "./investmentPenetration.vue?vue&type=style&index=0&id=269cebe4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269cebe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269cebe4')) {
      api.createRecord('269cebe4', component.options)
    } else {
      api.reload('269cebe4', component.options)
    }
    module.hot.accept("./investmentPenetration.vue?vue&type=template&id=269cebe4&scoped=true", function () {
      api.rerender('269cebe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/investmentPenetration.vue"
export default component.exports